import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import countries from 'country-calling-code';
var UsaStates = require('usa-states').UsaStates;

import {
  Modal,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
} from 'react-bootstrap';
import actions from '../../redux/actions';

class EditClaimant extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
      lastName: '',
      middleName: '',
      organization: '',
      states: [],
      isAuthor: false,
      address: '',
      city: '',
      stateVal: '',
      zip: '',
      country: '',
    };
  }

  componentWillMount() {
    const usStates = new UsaStates();
    const states = [{ abbreviation: 'Non-U.S.' }, ...usStates.states];
    this.setState({ states });
  }

  opened() {
    const { claimant, authors } = this.props;

    this.setState({
      organization: claimant ? claimant.organization || '' : '',
      firstName: claimant ? claimant.firstName || '' : '',
      middleName: claimant ? claimant.middleName || '' : '',
      lastName: claimant ? claimant.lastName || '' : '',
      address: claimant ? claimant.address || '' : '',
      city: claimant ? claimant.city || '' : '',
      stateVal: claimant ? claimant.state || '' : '',
      zip: claimant ? claimant.zip || '' : '',
      country: claimant ? claimant.country || '' : '',
    });

    if (claimant) {
      const index = _.findIndex(
        authors,
        (author) =>
          author.firstName === claimant.firstName &&
          author.lastName === claimant.lastName &&
          author.middleName === claimant.middleName &&
          author.organization === claimant.organization
      );
      this.setState({ isAuthor: index !== -1 });
    } else {
      this.setState({ isAuthor: false });
    }
  }

  handleFirstName(e) {
    this.setState({
      firstName: e.target.value,
    });
    this.clearRestField();
  }

  handleLastName(e) {
    this.setState({
      lastName: e.target.value,
    });
    this.clearRestField();
  }

  handleMiddleName(e) {
    this.setState({
      middleName: e.target.value,
    });
    this.clearRestField();
  }

  clearRestField() {
    this.setState({
      organization: '',
    });
  }

  handleOrganization(e) {
    this.setState({
      organization: e.target.value,
      firstName: '',
      lastName: '',
      middleName: '',
    });
  }

  handleChange = (type, e) => {
    this.setState({ [type]: e.target.value });
  };

  close() {
    this.props.onClose();
  }

  save(e) {
    e.preventDefault();
    const {
      firstName,
      lastName,
      middleName,
      organization,
      address,
      city,
      stateVal,
      zip,
      country,
    } = this.state;

    let data = {};
    if (!organization) {
      data = {
        firstName,
        lastName,
        middleName,
        address,
        city,
        state: stateVal,
        zip,
        country,
      };
    } else {
      data = {
        organization,
        address,
        city,
        state: stateVal,
        zip,
        country,
      };
    }

    this.props.hideAlert();

    if (
      !data.address ||
      !data.city ||
      !data.state ||
      !data.zip ||
      !data.country
    ) {
      this.props.alert('error', 'Please check the required fields.');
      return;
    }

    if (!organization && (!firstName || !lastName)) {
      this.props.alert('error', 'You must list an organization OR a person');
      return;
    }

    this.props.onSave(data);
    this.close();
  }

  render() {
    const {
      states,
      firstName,
      lastName,
      middleName,
      organization,
      isAuthor,
      address,
      city,
      stateVal,
      zip,
      country,
    } = this.state;

    return (
      <Modal
        className="edit-author-modal edit-claimants-modal"
        show={this.props.open}
        onEnter={() => this.opened()}
        onHide={() => this.close()}
      >
        <Form inline onSubmit={(e) => this.save(e)}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Claimant</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>You can list an organization OR a person as a claimant.</p>
            <p>
              If you listed a pseudonym in the previous section, enter it in the
              first and last name fields below.
            </p>

            <FormGroup>
              <ControlLabel className="w-100px">
                <span className="text-red">*</span>First Name:{' '}
              </ControlLabel>
              <FormControl
                disabled={isAuthor}
                type="text"
                value={firstName}
                onChange={(e) => this.handleFirstName(e)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel className="w-100px">Middle Name: </ControlLabel>
              <FormControl
                disabled={isAuthor}
                type="text"
                value={middleName}
                onChange={(e) => this.handleMiddleName(e)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel className="w-100px">Last Name: </ControlLabel>
              <FormControl
                disabled={isAuthor}
                type="text"
                value={lastName}
                onChange={(e) => this.handleLastName(e)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel className="w-100px">Organization: </ControlLabel>
              <FormControl
                disabled={isAuthor}
                type="text"
                value={organization}
                onChange={(e) => this.handleOrganization(e)}
              />
              <p className="small">
                If an organization owns this copyright, enter the organization's
                name here.
              </p>
            </FormGroup>

            <FormGroup>
              <ControlLabel className="w-100px">
                <span className="text-red">*</span>Address:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                value={address}
                onChange={(e) => this.handleChange('address', e)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel className="w-100px">
                <span className="text-red">*</span>City:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                value={city}
                onChange={(e) => this.handleChange('city', e)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel className="w-100px">
                <span className="text-red">*</span>State:{' '}
              </ControlLabel>
              <FormControl
                componentClass="select"
                value={stateVal}
                onChange={(e) => this.handleChange('stateVal', e)}
              >
                <option disabled key={-1} value={-1}>
                  Select State
                </option>
                {states.map((item, i) => (
                  <option key={i} value={item.abbreviation}>
                    {item.abbreviation}
                  </option>
                ))}
              </FormControl>
            </FormGroup>
            <FormGroup>
              <ControlLabel className="w-100px">
                <span className="text-red">*</span>Zip/Postal:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                value={zip}
                onChange={(e) => this.handleChange('zip', e)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel className="w-100px">
                <span className="text-red">*</span>Country:{' '}
              </ControlLabel>
              <FormControl
                componentClass="select"
                value={country}
                onChange={(e) => this.handleChange('country', e)}
              >
                <option disabled key={-1} value={-1}>
                  Select Country
                </option>
                {countries.map((country, i) => (
                  <option key={i} value={country.country}>
                    {country.country}
                  </option>
                ))}
              </FormControl>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <div className="actions">
              <button type="submit">Save</button>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(null, mapDispatchToProps)(EditClaimant);



// WEBPACK FOOTER //
// src/components/Copyright/EditClaimantPopup.jsx